import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { order_apis } from "../ApiConst";
import { axiosInstance } from "../axios";
import { Token } from "../Token";

export const Add_To_Cart = async (id, currency, quantity) => {
  try {
    const orderId = localStorage.getItem(STORAGE_CONSTANTS.ORDER_ID);
    const data = {
      currency: currency === "NPR" ? "NPR" : "USD",
      qty: quantity,
      product_id: id,
      name_variation: null,
    };
    if (orderId) {
      data["order_id"] = orderId;
    }
    const response = await axiosInstance.post(order_apis.add_to_cart(), data, {
      useUserToken: false,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const Update_Cart = async (currency, quantity, id, order) => {
  try {
    const data = {
      currency: currency === "NPR" ? "NPR" : "USD",
      qty: quantity,
      product_id: id,
      name_variation: null,
    };
    if (order) {
      data["order_id"] = order;
    }

    // Use axiosInstance and pass useUserToken: true to use userToken from localStorage
    return await axiosInstance.put(order_apis.update_cart(), data, {
      useUserToken: false,
    });
  } catch (error) {
    throw error;
  }
};

export const Remove_From_Cart = async (currency, id, order) => {
  const params = {
    currency: currency === "NPR" ? "NPR" : "USD",
    product_id: parseInt(id),
    name_variation: "S",
    order_id: parseInt(order),
  };
  try {
    const response = await axiosInstance.delete(order_apis.remove_from_cart(), {
      data: params,
      useUserToken: false,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const View_Cart = async () => {
  try {
    return await axiosInstance.get(order_apis.view_cart(), {
      useUserToken: false,
      params: {
        order_id: localStorage.getItem(STORAGE_CONSTANTS.ORDER_ID),
        currency: "NPR",
      },
    });
  } catch (error) {
    throw error;
  }
};

export const applyCoupon = async (currency, code, userToken) => {
  try {
    return await axiosInstance.post(
      order_apis.apply_coupon(),
      {
        currency: currency === "NPR" ? "NPR" : "USD",
        code: code,
        status: false,
      },
      {
        headers: {
          Authorization: userToken ? `Token ${userToken}` : Token,
        },
      }
    );
  } catch (error) {
    throw error;
  }
};

export const Order_list = async (userToken, currentPage) => {
  try {
    return await axiosInstance.get(order_apis.order_list(), {
      useUserToken: true,
      params: {
        page: currentPage,
      },
    });
  } catch (error) {
    throw error;
  }
};

export const Sort_Order_list = async (sortValue) => {
  try {
    return await axiosInstance.get(order_apis.sort_order_list(sortValue), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const COD_Payment = async (payload) => {
  try {
    return await axiosInstance.post(order_apis.cod_payment(), payload, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const Past_Orders = async (currentPage) => {
  try {
    return await axiosInstance.get(order_apis.past_orders(currentPage), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const Search_Past_Orders = async (id, storeId, currentPage) => {
  const data = {
    id: storeId,
    product_name: id,
    store_based: false,
  };
  try {
    return await axiosInstance.post(
      // getCurrentPage(order_apis.search_past_order, {page: currentPage, limit: limit})
      // `api/v0/orders/search-order/?page=${currentPage}`,
      order_apis.search_past_order(currentPage),
      data,
      {
        useUserToken: true,
      }
    );
  } catch (error) {
    throw error;
  }
};

export const Cancel_Order = async (payload) => {
  try {
    return await axiosInstance.post(order_apis.cancel_order(), payload, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const View_Past_Orders = async (id) => {
  try {
    return await axiosInstance.get(order_apis.view_past_orders(id), {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const fetchCancellationReasons = async () => {
  try {
    const response = await axiosInstance.get(
      order_apis.fetch_cancellation_reasons(),
      {
        useUserToken: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching cancellation reasons:", error);
    throw error;
  }
};

export const fetchOrderCancellationReasons = async () => {
  try {
    const response = await axiosInstance.get(
      order_apis.fetch_order_cancellation_reasons(),
      {
        useUserToken: true,
      }
    );
    return response.data.cancel_reason_list;
  } catch (error) {
    console.error("Error fetching order cancellation reasons:", error);
    throw error;
  }
};

export const cancelLineItem = async (
  orderId,
  lineItemId,
  cancelReason,
  otherCancelReason
) => {
  // Prepare request payload
  try {
    const params = {
      order_id: orderId,
      product_id: lineItemId,
      cancel_reason: cancelReason,
      order_status: "cancelled", // Pass order_status as "cancelled"
      ...(cancelReason === "Other Reason" && {
        other_reason: otherCancelReason,
      }), // Include other_reason only if reason is 'Other'
    };

    const response = await axiosInstance.post(
      order_apis.cancel_line_item(),
      params, // Use params object for the request payload
      {
        useUserToken: true,
      }
    );

    return response.data; // Return the response data
  } catch (error) {
    throw error;
  }
};

export const fetchSellerCancellationReasons = async () => {
  try {
    const response = await axiosInstance.get(
      order_apis.fetch_seller_cancellation_reasons(),
      {
        useUserToken: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching seller cancellation reasons:", error);
    throw error;
  }
};

export const sellerCancelLineItem = async (
  orderId,
  lineItemId,
  orderStatus,
  cancelReason,
  otherReason
) => {
  try {
    // Prepare request payload
    const params = {
      order_id: orderId,
      product_id: lineItemId,
      order_status: orderStatus,
      cancel_reason: cancelReason,
      ...(cancelReason === "Other Reason" && { other_reason: otherReason }), // Include other_reason only if reason is 'Other'
    };

    // Make the POST request
    const response = await axiosInstance.post(
      order_apis.seller_cancel_line_item(),
      params, // Use params object for the request payload
      {
        useUserToken: true,
      }
    );

    return response.data; // Return the response data
  } catch (error) {
    throw error;
  }
};

export const getProductAvailability = async (orderId) => {
  const data = {
    order_id: orderId,
  };
  try {
    // Make the POST request
    const response = await axiosInstance.post(
      order_apis.get_product_availability(),
      data,
      {
        useUserToken: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching product availability:", error);
    throw error;
  }
};

export const BuyAgainProducts = async () => {
  try {
    return await axiosInstance.get(order_apis.buy_again_products, {
      useUserToken: true,
      maxBodyLength: Infinity,
    });
  } catch (error) {
    throw error;
  }
};

export const Search_Store_Orders = async (payload, currentPage) => {
  try {
    return await axiosInstance.post(
      `api/v0/orders/search-order/?page=${currentPage}`,
      payload,
      { useUserToken: true }
    );
  } catch (error) {
    throw error;
  }
};

export const Search_Store_Orders_Suggestions = async (payload) => {
  try {
    return await axiosInstance.post("api/v0/orders/search-order/", payload, {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const Cart_OrderId = async () => {
  try {
    return await axiosInstance.get("api/v0/orders/cart/", {
      useUserToken: true,
    });
  } catch (error) {
    throw error;
  }
};

export const Delivery_Method = async (orderId, storeId, method) => {
  try {
    let data = {
      order_id: orderId,
      store_id: storeId,
      delivery_method:
       method === "Delivery" || method === "delivery"
    ? "DELIVERY"
    : method === "Pick Up" || method === "Pickup" || method === "pickup"
    ? "PICKED_UP"
    : "",

    };
    return await axiosInstance.post(
      `api/v0/orders/order/delivery_method/`,
      data,
      {
        useUserToken: true,
      }
    );
  } catch (error) {
    throw error;
  }
};

export const fetchOrderDetailsStatus = async () => {
  try {
    const response = await axiosInstance.get(
      `api/v0/orders/order_details/status/`,
      {
        useUserToken: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOrderDetails = async (orderId) => {
  try {
    const response = await axiosInstance.get(
      `api/v0/store/order_list/${orderId}/`,
      {
        useUserToken: true,
        maxBodyLength: Infinity,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching order details", error);
    throw error; // Throw the error for handling by the caller
  }
};
